App.controller('UserUpdateCtrl', UserUpdateCtrl);

UserUpdateCtrl.$inject = [
    'DialogService',
    'userFactory',
    'user'
];

function UserUpdateCtrl(DialogService, userFactory, user) {
    var vm = this;

    vm.user = user;

    vm.update = update;

    function update() {
        userFactory.update(vm.user).then(function() {
            DialogService.success('User has been successfully updated');
        });
    }
}